<span *ngIf="observableLocales$ | async as placeholderLocales">
  <!--Hidden if not on iOS-->
  <span (click)="openTooltip()" [hidden]="!iOS">
    <app-locale localeKey="{{tooltipKey}}" localeView="{{tooltipView}}" style="display: inline-flex"></app-locale>
  </span>
  <!--Hidden if on iOS-->
  <span [matTooltipPosition]="tooltipPosition" matTooltip="{{placeholderLocales | localebykey:localeKey:localeView}}"
    [hidden]="iOS" [matTooltipClass]="{'custom-tooltip': true}">
    <app-locale localeKey="{{tooltipKey}}" localeView="{{tooltipView}}" style="display: inline-flex"></app-locale>
  </span>
</span>